import Button from "react-bootstrap/Button";
import BootstrapModal from "react-bootstrap/Modal";

const CustomModal = ({
  heading,
  message,
  buttonText,
  showModal,
  handleClose,
  handleSubmitButton,
}) => {
  return (
    <BootstrapModal
      show={showModal}
      onHide={() => {
        handleClose();
      }}
      scrollable
    >
      <BootstrapModal.Header closeButton>
        <BootstrapModal.Title>{heading}</BootstrapModal.Title>
      </BootstrapModal.Header>
      <BootstrapModal.Body>
        <div
          style={{
            whiteSpace: "pre-wrap",
            maxHeight: "70vh",
            overflowY: "auto",
          }}
        >
          {message}
        </div>
      </BootstrapModal.Body>
      <BootstrapModal.Footer>
        <Button
          variant="secondary"
          onClick={() => {
            handleClose();
          }}
        >
          Close
        </Button>
        <Button
          variant="primary"
          onClick={() => {
            handleSubmitButton();
          }}
        >
          {buttonText}
        </Button>
      </BootstrapModal.Footer>
    </BootstrapModal>
  );
};

export default CustomModal;
